.sidebar-primary-button-icon{font-variation-settings:"FILL" 1}.sidebar-primary-button-inner{width:189px;height:42px;justify-content:left;margin-top:3.5px;margin-bottom:3.5px}
/*# sourceMappingURL=sidebar-primary-button.component-C2JTOSKL.css.map */
